/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiCrossRefTrailerType.ts        *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-cross-ref-trailer-type";

export class AutogenModelEdiCrossRefTrailerType<RowType extends ModelRow> extends Endpoint<RowType, RowEdiCrossRefTrailerTypeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiCrossRefTrailerType extends ModelRow<RowEdiCrossRefTrailerTypeFields> {
	constructor(values?: Partial<RowEdiCrossRefTrailerTypeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiCrossRefTrailerTypeFields {
	company_id: string;
	edi_code: string;
	"equipment_type.applies_to": string;
	"equipment_type.company_id": string;
	"equipment_type.descr": string;
	"equipment_type.equip_length": number;
	"equipment_type.equip_width": number;
	"equipment_type.exchange_type": string;
	"equipment_type.fms_length": string;
	"equipment_type.fms_type": string;
	"equipment_type.id": string;
	"equipment_type.picture_resource": string;
	"equipment_type.pnn_code_id": string;
	"equipment_type.web_order": number;
	equipment_type_id: string;
	fgi_packaging_type_code: string;
	hdr_uid: number;
	id: string;
	la_business_unit: string;
	order_type_id: string;
	partner_id: string;
	revenue_code_id: string;
	seg_alloc_code: string;
	version: string;
}

